import React from 'react'
import { Stack, Box } from '@mui/material'
import ChannelCard from './ChannelCard'
import VideoCard from './VideoCard'

const Videos = ({videos, direction}) => {
    console.log(videos);
    if(!videos?.length) return 'Loading...'
  return (
    <Stack flexDirection={direction || 'row'} flexWrap='wrap' justiftContent='start' gap={1}>
        {videos.map((item, idx) => (
            <Box key={idx}>
                {item.id && <VideoCard video={item} />}
                {item.id.channelId && <ChannelCard channelDetail={item} />}
            </Box>
        ))}

    </Stack>
  )
}

export default Videos